import { motion } from 'framer-motion';

const ModernTravelCarousel = ({ tabs, activeIndex, onSelectTab }) => {
  const iconFilter = { filter: 'hue-rotate(-45deg) saturate(2)' };

  const getCardAnimation = (idx) => {
    let offset = idx - activeIndex;
    if (offset < -1) offset += tabs.length;
    if (offset > 2) offset -= tabs.length;

    if (offset === 0) {
      return { x: '0%', scale: 1, zIndex: 30, opacity: 1, filter: 'blur(0px)' };
    } else if (offset === 1) {
      return { x: '110%', scale: 1, zIndex: 20, opacity: 1, filter: 'blur(0px)' };
    } else if (offset === -1) {
      return { x: '-110%', scale: 1, zIndex: 20, opacity: 1, filter: 'blur(0px)' };
    } else {
      return { x: '220%', scale: 1, zIndex: 10, opacity: 0, filter: 'blur(0px)' };
    }
  };

  return (
    <div className="relative w-full h-[460px] sm:h-[480px] md:h-[500px] flex items-center justify-center overflow-hidden px-2 sm:px-4 md:px-0">
      {tabs.map((tab, idx) => {
        const isCenter = idx === activeIndex;
        return (
          <motion.div
            key={idx}
            animate={getCardAnimation(idx)}
            transition={{ duration: 0.5, ease: 'easeOut' }}
            className={`absolute w-[92vw] sm:w-[85vw] md:w-[68vw] max-w-5xl h-[430px] sm:h-[450px] md:h-[460px] bg-[#f8fafc] rounded-2xl sm:rounded-[2rem] md:rounded-[2.5rem] flex flex-col md:flex-row overflow-hidden cursor-pointer group transition-all duration-500 ${
              isCenter
                ? 'border-t-[6px] border-t-[#067978] shadow-[0_20px_60px_rgba(6,121,120,0.15)]'
                : 'border border-gray-100 shadow-[0_10px_40px_rgba(0,0,0,0.06)]'
            }`}
            onClick={() => onSelectTab(idx)}
          >
            {/* Card Content - Left Side */}
            <div className="w-full md:w-1/2 p-5 sm:p-8 md:p-10 lg:p-14 flex flex-col justify-center space-y-2 sm:space-y-4 relative z-40">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#1a2b49] leading-tight transition-colors duration-300 group-hover:text-[#067978]">
                {tab.title}
              </h3>
              <p className="text-gray-500 font-normal text-xs sm:text-sm md:text-base leading-relaxed max-w-sm">
                {tab.desc}
              </p>
            </div>

            {/* Card Image - Right Side */}
            <div className="w-full md:w-1/2 h-44 sm:h-52 md:h-full flex items-end justify-center pb-3 sm:pb-4 md:pb-8 pr-2 sm:pr-4 md:pr-8 relative z-30 overflow-hidden">
              <img
                src={tab.img}
                alt={tab.title}
                className="w-[75%] sm:w-[85%] max-h-full object-contain mix-blend-multiply drop-shadow-2xl transition-transform duration-700 ease-out group-hover:scale-110 group-hover:-translate-y-4"
                style={iconFilter}
              />
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default ModernTravelCarousel;
